import { render, staticRenderFns } from "./chatdetail.vue?vue&type=template&id=bd7df86a&scoped=true&"
import script from "./chatdetail.vue?vue&type=script&lang=js&"
export * from "./chatdetail.vue?vue&type=script&lang=js&"
import style0 from "./chatdetail.vue?vue&type=style&index=0&id=bd7df86a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7df86a",
  null
  
)

export default component.exports